<script>
  import {
    faSpinner as iconSpinner,
    faChartPie as iconDashboard,
    faThumbtack as iconTodoList,
    faCubes as iconProjectList,
    faCog as iconSettings,
    faPowerOff as iconLogout,
    faUsers as iconUserList,
    faUser as iconProfile,
    faBuilding as iconCompanyList
  } from '@fortawesome/free-solid-svg-icons'
  import {
    faAddressCard as iconCustomerList,
    faClock as iconWorkingHourList,
    faMoneyBillAlt as iconInvoiceList
  } from '@fortawesome/free-regular-svg-icons'
  import { mapGetters } from 'vuex'
  import LogoutCountDown from './components/generic/LogoutCountDown'
  import Toasts from './components/generic/Toasts.vue'

  export default {
    name: 'das-projekt',
    components: {
      LogoutCountDown,
      Toasts
    },
    data () {
      return {
        menuBar: {
          left: [
            {name: 'Dashboard', icon: iconDashboard, exact: true},
            {name: 'WorkingHour', icon: iconWorkingHourList},
            {name: 'Invoice', icon: iconInvoiceList},
            {name: 'Customer', icon: iconCustomerList},
            // {name: 'TodoList', icon: iconTodoList},
            {name: 'Project', icon: iconProjectList},
            {name: 'User', icon: iconUserList},
            {name: 'Company', icon: iconCompanyList},
          ],
          right: []
        },
        iconSettings,
        iconSpinner,
        iconLogout,
        iconProfile,
      }
    },
    computed: {
      ...mapGetters({
        userId: 'authentication/id',
        name: 'authentication/username',
        companyIds: 'authentication/companies',
        selectedCompanyId: 'authentication/selectedCompanyId',
        isLoading: 'isLoading',
        toasts: 'toasts/items'
      }),
      companies () {
        return this.companyIds
      },
    },
    watch: {
      '$route' () {
        this.setTitle()
      }
    },
    methods: {
      determineTrail (route) {
        return this.$route.matched.some((test) => {
          return test.name === route.name
        }) ? 'router-link-active router-link-trail' : ''
      },
      setTitle () {
        const route = this.$route
        document.title = this.$t('title.' + route.name, route.params) + ' - das-projekt'
      },
      switchCompany (company) {
        this.$store.dispatch('authentication/selectCompany', company.uuid)
      }
    },
    mounted: function () {
      this.setTitle()
      this.$store.dispatch('authentication/refresh')
    }
  }
</script>
<template>
  <div id="app">
    <b-navbar toggleable="lg" type="light" variant="light" sticky>
      <b-navbar-brand href="#/">Das Projekt</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav v-if="userId">
          <b-nav-item
            v-for="item in menuBar.left"
            :key="item.name"
            :to="{ name: item.name }"
            :exact="item.exact"
            :link-classes="determineTrail(item)"
          ><font-awesome-icon :icon="item.icon" size="lg" /> {{$t('navButton.' + item.name)}}</b-nav-item>
          <b-nav-item-dropdown v-if="userId">
            <template slot="button-content"><font-awesome-icon :icon="iconSettings" size="lg" /> {{$t('navButton.Settings')}}</template>
            <b-dropdown-item :to="{name: 'UserUpdate', params: { id: userId }}"><font-awesome-icon :icon="iconProfile" size="lg" /> Profile</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-for="company in companies"
              :key="company.uuid"
              :active="selectedCompanyId === company.uuid"
              @click="switchCompany(company)"
            >{{company.name}} </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isLoading"><font-awesome-icon :icon="iconSpinner" spin /> Loading...</b-nav-item>
          <b-nav-item-dropdown right v-if="userId">
            <!-- Using 'button-content' slot -->
            <template slot="button-content"><em>User</em></template>
            <b-dropdown-item :to="{name: 'UserUpdate', params: { id: userId }}"><font-awesome-icon :icon="iconProfile" size="lg" /> Profile</b-dropdown-item>
            <b-dropdown-item @click="$store.dispatch('authentication/logout')"><font-awesome-icon :icon="iconLogout" size="lg" /> Sign Out {{ name }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <toasts></toasts>
    <router-view :key="$route.fullPath + selectedCompanyId" class="content"></router-view>
    <b-navbar class="sticky-bottom" variant="light">
      <li class="navbar-text navbar-right"><logout-count-down></logout-count-down></li>
    </b-navbar>
  </div>
</template>
